import { Schema as S } from "effect";

export const GetTiContextSchema = S.Struct({
  MandantId: S.optional(S.String),
  ClientSystemId: S.optional(S.String),
  WorkplaceId: S.optional(S.String),
  MandantName: S.optional(S.String),
  WorkplaceName: S.optional(S.String),
});

export const CardSchema = S.Struct({
  CardHandle: S.optional(S.String),
  CardType: S.optional(S.String),
  // Add other card properties as needed
});

export type Card = S.Schema.Type<typeof CardSchema>;

export const GetTiItemSchema = S.Struct({
  _id: S.optional(S.Record(S.String, S.Unknown)),
  CtIds: S.optional(S.Array(S.String)),
  CtNames: S.optional(S.Array(S.String)),
  terminals: S.optional(S.Array(S.Unknown)),
  profiles: S.optional(S.Array(S.Unknown)),
  context: S.optional(GetTiContextSchema),
  SMCBCards: S.optional(S.Array(CardSchema)),
  HBACards: S.optional(S.Array(CardSchema)),
});

export const GetTiResponseSchema = S.Array(GetTiItemSchema);

export type GetTiResponse = S.Schema.Type<typeof GetTiResponseSchema>;
